import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setAuthModalOpen } from "../../store/features/authModalSlice";

const ProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const user = useSelector((state) => state.user?.user);

  useEffect(() => {
    if (!user) {
      dispatch(setAuthModalOpen(true));
    }
  }, [user, dispatch]);

  useEffect(() => {
    if (user && location.state?.from) {
      navigate(location.state.from, { replace: true });
    }
  }, [user]);

  if (!user) {
    return null; // only modal shows
  }

  return children;
};

export default ProtectedRoute;
